import {
  useAction,
  useOptimisticAction,
  type HookSafeActionFn,
  type HookSafeStateActionFn,
} from 'next-safe-action/hooks';
import { useStateAction } from 'next-safe-action/stateful-hooks';
import { type ZodSchema } from 'zod';
import { handleErrorToasts } from '../errorToasts';

export const useSafeAction: typeof useAction = (safeActionFn, callbacks) => {
  return useAction(safeActionFn, {
    ...(callbacks ?? {}),
    onError: (args) => {
      handleErrorToasts(args.error.serverError as string);
      callbacks?.onError?.(args);
    },
  });
};

export const useOptimisticSafeAction: typeof useOptimisticAction = (
  safeActionFn,
  utils,
) => {
  return useOptimisticAction(safeActionFn, {
    ...utils,
    onError: (args) => {
      handleErrorToasts(args.error.serverError as string);
      utils?.onError?.(args);
    },
  });
};

export const useSafeStateAction: typeof useStateAction = (
  safeActionFn,
  utils,
) => {
  return useStateAction(safeActionFn, {
    ...utils,
    onError: (args) => {
      handleErrorToasts(args.error.serverError as string);
      utils?.onError?.(args);
    },
  });
};

export type SimpleHookSafeActionFn<
  InputSchema extends ZodSchema,
  OutputSchema = void,
> = HookSafeActionFn<string, InputSchema, [], any, any, OutputSchema>;

export type SimpleHookSafeStateActionFn<
  InputSchema extends ZodSchema,
  OutputSchema,
> = HookSafeStateActionFn<string, InputSchema, [], any, any, OutputSchema>;
